import React, { FC, useState } from 'react';
import RadioButton from 'components/common/radioButtons/radioButtons';
import buttons from 'style/buttons.module.scss';
import close from 'style/imgs/icons/close-icon.svg';
import styles from './index.module.scss';

const radioButtonsContent = [
  {
    label: 'This event',
    value: 'this_event',
  },
  {
    label: 'This and following events',
    value: 'this_following',
  },
  {
    label: 'All events',
    value: 'all',
  },
];

interface RecurringModalProps {
  modalType: string;
  action: (type: string) => void;
  closeModal: () => void;
}

const RecurringModal: FC<RecurringModalProps> = ({
  modalType,
  action,
  closeModal,
}) => {
  const [selectedType, setSelectedType] = useState('');

  const handleSetType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedType(e.target.value);
  };

  return (
    <div className={styles.recurringModal}>
      <div className={styles.modalClose}>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            closeModal();
          }}
        >
          <img src={close} alt="close" />
        </button>
      </div>
      <h3>
        {modalType === 'delete'
          ? 'Delete recurring event'
          : 'Edit recurring event'}
      </h3>
      <div className={styles.radioGroup}>
        <RadioButton handleClick={handleSetType} data={radioButtonsContent} />
      </div>
      <div className={styles.recurringButtons}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            closeModal();
          }}
          className={buttons.buttonOutline}
          type="button"
        >
          Cancel
        </button>
        <button
          type="submit"
          className={buttons.buttomPrimary}
          disabled={selectedType === ''}
          onClick={(e) => {
            e.stopPropagation();
            action(selectedType);
          }}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default RecurringModal;
